import * as React from "react";
import { BookOpen, Calendar, Home, Settings, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const navigationItems = [
  {
    url: "/mentor/dashboard",
    label: "Dashboard",
    icon: Home,
  },
  { url: "/mentor/mentees", label: "My Mentees", icon: Users },
  {
    url: "/mentor/appointments",
    label: "Sessions",
    icon: Calendar,
  },
  // { url: "/mentor/analytics", label: "Analytics", icon: BarChart3 },
  { url: "/mentor/resources", label: "Resources", icon: BookOpen },
  // {
  //   url: "/mentor/messages",
  //   label: "Messages",
  //   icon: MessageSquare,
  //   badge: "2",
  // },
];

export function AppSidebar() {
  const [sidebarCollapsed] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      className={`${sidebarCollapsed ? "w-16" : "w-64"} flex flex-col border-r border-primary/10 bg-white shadow-lg transition-all duration-300`}
    >
      {/* Logo Section */}
      <div className="flex h-[78px] items-center border-b border-primary/10 px-4">
        <img src="/logo-vincer.png" alt="Logo" className="h-[40px] w-[120px]" />
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-2 p-4">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          const active = location.pathname.startsWith(item.url);
          return (
            <button
              key={item.url}
              onClick={() => navigate(item.url)}
              className={`relative flex w-full items-center gap-3 rounded-lg px-3 py-2 transition-all duration-200 ${
                active
                  ? "bg-gradient-primary text-white shadow-lg"
                  : "text-muted-foreground hover:bg-primary/5 hover:text-primary"
              }`}
            >
              <Icon className="size-5 shrink-0" />
              {!sidebarCollapsed && (
                <>
                  <span className="font-medium">{item.label}</span>
                  {/* {item.badge && (
                    <Badge
                      className={`ml-auto ${
                        active
                          ? "bg-white/20 text-white"
                          : "bg-primary text-white"
                      }`}
                    >
                      {item.badge}
                    </Badge>
                  )} */}
                </>
              )}
              {/* {sidebarCollapsed && item.badge && (
                <div className="absolute -right-1 -top-1 flex size-5 items-center justify-center rounded-full bg-primary text-xs text-white">
                  {item.badge}
                </div>
              )} */}
            </button>
          );
        })}
      </nav>

      {/* Sidebar Footer */}
      <div className="space-y-2 border-t border-primary/10 p-4">
        <button className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all duration-200 hover:bg-primary/5 hover:text-primary">
          <Settings className="size-5 shrink-0" />
          {!sidebarCollapsed && <span className="font-medium">Settings</span>}
        </button>
      </div>
    </div>
  );
}
